module.exports = __webpack_public_path__ + "img/slogan.b6faf7c7.png";